import acquisitionModeRoute from "features/acquisitionMode/routes";
import authorRoute from "features/author/routes";
import biblevelRoute from "features/biblevel/routes";
import bindingTypeRoute from "features/bindingType/routes";
import classificationRoute from "features/classification/routes";
import courseRoute from "features/course/routes";
import currencyRoute from "features/currency/routes";
import countryRoute from "features/country/routes";
import departmentRoute from "features/department/routes";
import entryExitRoute from "features/entryExit/routes";
import fineRoute from "features/fine/routes";
import holidayRoute from "features/holiday/routes";
import instituteRoute from "features/institute/routes";
import instituteWiseMaterialTypeRoute from "features/instituteWiseMaterialType/routes";
import libraryWiseInstituteRoute from "features/libraryWiseInstitute/routes";
import issueRoute from "features/issue/routes";
import languagesRoute from "features/language/routes";
import libraryRoute from "features/library/routes";
import materialRoute from "features/material/routes";
import materialStatusRoute from "features/materialStatus/routes";
import materialTypeRoute from "features/materialtype/routes";
import memberRoute from "features/member/routes";
import memberRenewRoute from "features/memberRenew/routes";
import memberStatusRoute from "features/memberStatus/routes";
import memberTypeRoute from "features/memberType/routes";
import memberTypeWiseMaterialTypeConfig from "features/memberTypeWiseMaterialTypeConfig/routes";
import memberTypeWiseMaterialTypeConfigRoute from "features/memberTypeWiseMaterialTypeConfig/routes";
import memberTypewiseSectionConfig from "features/memberTypewiseSectionConfig/routes";
import physicalMediumRoute from "features/physicalMedium/routes";
import programRoute from "features/program/routes";
import publicationRoute from "features/publication/routes";
import rackRoute from "features/rack/routes";
import reportsRoute from "features/reports/routes";
import sectionRoute from "features/section/routes";
import specializationRoute from "features/specialization/routes";
import supplierRoute from "features/supplier/routes";
import universityRoute from "features/university/routes";
import securityRoutes from "features/security/routes";
import dashboardRoutes from "features/dashboard/routes";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import DashboardLayout from "layout/Dashboard/index2";
import LoginRoutes from "./LoginRoutes";
import ErrorBoundary from "./ErrorBoundary";
import receiptRoutes from "features/receipt/routes";
import libraryRoutes from "features/libraryDashboard/routes";
import changeRackRoutes from "features/changeRack/routes";
import changeSectionRoutes from "features/changeSection/routes";
import opacRoutes from "features/opac/routes";
import profileImageRoutes from "features/ReactUplody/routes";
import changeDueDateRoutes from "features/changeDueDate/routes";
import noDueCertificate from "features/noDueCertificate/routes";
import barCodesRoutes from "features/barCode/routes";
import importMaterialRoutes from "features/importMaterial/routes";
import finePolicyRoutes from "features/finePolicy/routes";
import importMemberRoutes from "features/importMember/routes";
import admissionYearRoutes from "features/admissionYear/routes";
import emailRoutes from "features/email/routes";
import reservationRoute from "features/reservation/routes";
import resetItemRoutes from "features/resetItem/routes";
import resetMemberRoutes from "features/resetMember/routes";
import circulationGroupRoutes from "features/circulationGroup/routes";
import stockVerificationRoutes from "features/stockVerification/routes";
import topBooksPerformanceRoutes from "features/topBooksPerformance/routes";
import budgetRoutes from "features/budget/routes";
import notificationRoutes from "features/notification/routes";
import bookTransferRoutes from "features/bookTransfer/routes";
import biometricRoutes from "features/biometric/routes";
import entryExitDashboardRoutes from "features/entryExitDashboard/routes";

import internalILLRoutes from "features/internalILL/routes";

const router = createBrowserRouter([
  {
    path: "/admin",
    element: <DashboardLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      dashboardRoutes,
      acquisitionModeRoute,
      authorRoute,
      biblevelRoute,
      bindingTypeRoute,
      classificationRoute,
      courseRoute,
      currencyRoute,
      countryRoute,
      departmentRoute,
      entryExitRoute,
      fineRoute,
      holidayRoute,
      instituteRoute,
      instituteWiseMaterialTypeRoute,
      libraryWiseInstituteRoute,
      issueRoute,
      reservationRoute,
      languagesRoute,
      libraryRoute,
      materialRoute,
      materialStatusRoute,
      materialTypeRoute,
      memberRoute,
      memberRenewRoute,
      memberStatusRoute,
      memberTypeRoute,
      memberTypeWiseMaterialTypeConfig,
      memberTypeWiseMaterialTypeConfigRoute,
      memberTypewiseSectionConfig,
      noDueCertificate,
      physicalMediumRoute,
      programRoute,
      publicationRoute,
      rackRoute,
      reportsRoute,
      sectionRoute,
      specializationRoute,
      supplierRoute,
      universityRoute,
      securityRoutes,
      receiptRoutes,
      libraryRoutes,
      changeRackRoutes,
      changeSectionRoutes,
      changeDueDateRoutes,
      barCodesRoutes,
      importMaterialRoutes,
      finePolicyRoutes,
      importMemberRoutes,
      admissionYearRoutes,
      emailRoutes,
      resetItemRoutes,
      resetMemberRoutes,
      circulationGroupRoutes,
      stockVerificationRoutes,
      topBooksPerformanceRoutes,
      budgetRoutes,
      notificationRoutes,
      bookTransferRoutes,
      biometricRoutes,
      entryExitDashboardRoutes,
      internalILLRoutes,
    ],
  },
  profileImageRoutes,
  LoginRoutes,
  opacRoutes,
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
